import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import PollIcon from '@material-ui/icons/Poll';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import ExposureIcon from '@material-ui/icons/Exposure';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import InputIcon from '@material-ui/icons/Input';
import { ListItem, colors } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
/*import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import DescriptionIcon from '@material-ui/icons/Description';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import ImageIcon from '@material-ui/icons/Image';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SettingsIcon from '@material-ui/icons/Settings';*/
import LockOpenIcon from '@material-ui/icons/LockOpen';

import { Profile, SidebarNav } from './components';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  item: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, token, profile, className, ...rest } = props;
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('profile');
    window.location.reload();
  };

  const classes = useStyles();

  const pages = [
    /*{
      title: 'หน้าหลัก',
      href: '/dashboard',
      icon: <DashboardIcon />,
      role:'member'
    },*/
    {
      title: 'ข้อมูลเงินเดือน',
      href: '/slipreport',
      icon: <MonetizationOnIcon />,
      role: 'member'
    },
    {
      title: 'ข้อมูลเงินเดือน.',
      href: '/slipreport',
      icon: <MonetizationOnIcon />,
      role: 'financeadmin'
    },
    {
      title: 'กรอกข้อมูลเงินเดือน',
      href: '/slipdata',
      icon: <NoteAddIcon />,
      role: 'financeadmin'
    },
    {
      title: 'ข้อมูลเงินเดือน..',
      href: '/slipreport',
      icon: <MonetizationOnIcon />,
      role: 'admin'
    },
    {
      title: 'กรอกข้อมูลเงินเดือน.',
      href: '/slipdata',
      icon: <NoteAddIcon />,
      role: 'admin'
    },
    {
      title: 'ข้อมูลเจ้าหน้าที่กรอกข้อมูล',
      href: '/usersmoneytypedata',
      icon: <HowToRegIcon />,
      role: 'admin'
    },
    {
      title: 'ข้อมูลรายการได้/หัก',
      href: '/moneytypedata',
      icon: <ExposureIcon />,
      role: 'admin'
    },
    {
      title: 'รายข้อมูลงานคลัง',
      href: '/reportdata',
      icon: <PollIcon />,
      role: 'admin'
    },
    {
      title: 'ดึงข้อมูล',
      href: '/loaddatas',
      icon: <AssignmentReturnedIcon />,
      role: 'admin'
    },
    /*,    
    {
      title: 'Typography',
      href: '/typography',
      icon: <TextFieldsIcon />,
      role:'member'
    },
    {
      title: 'Icons',
      href: '/icons',
      icon: <ImageIcon />,
      role:'member'
    },
    {
      title: 'Account',
      href: '/account',
      icon: <AccountBoxIcon />,
      role:'member'
    },
    {
      title: 'Settings',
      href: '/settings',
      icon: <SettingsIcon />,
      role:'admin'
    }*/,
    {
      title: 'ลงชื่อเข้าใช้',
      href: '/sign-in',
      icon: <LockOpenIcon />,
      role: 'nonmember'
    }
  ];

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Profile
          token={token}
        />
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          pages={pages}
          profile={profile}
        />
        <ListItem button className={classes.item} onClick={handleLogout}>
          <div  className={classes.icon}>
            <InputIcon />
          </div >ออกจากระบบ
        </ListItem>

      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  token: PropTypes.object,
  profile: PropTypes.object,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
